module.exports = __webpack_public_path__ + "public/img/computer.f6470b84.png";